import { useState } from 'react';
import { analyticsApi } from '../../../services/analytics-api.service';
import { triggerDownload } from '../../../hooks/useEngagementMetricsExport';
import { ExportButton } from '../../analytics/shared/ExportButton';
import { PIIExportDialog } from '../../analytics/shared/PIIExportDialog';
import type { ReferralListQueryParams } from '../../../types/engagement-metrics.types';

/**
 * Feature 117 slice 21: Referrals tab header action. Exports every row matching
 * the tab's search/filters/sort (no paging) after the PII consent dialog; the
 * backend audits it.
 */
export const ReferralsExportButton = ({ params }: { params: ReferralListQueryParams }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const [failed, setFailed] = useState(false);

  const handleConfirm = async () => {
    setIsExporting(true);
    setFailed(false);
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { cursor, limit, ...filters } = params;
      triggerDownload(await analyticsApi.exportReferralsCSV(filters), 'bquest-referrals-export');
    } catch {
      setFailed(true);
    } finally {
      setShowDialog(false);
      setIsExporting(false);
    }
  };

  return (
    <>
      <ExportButton
        onClick={() => setShowDialog(true)}
        isLoading={isExporting}
        label="Export CSV"
      />
      {failed && (
        <p role="alert" className="self-center text-sm text-red-600">
          Export failed. Try again.
        </p>
      )}
      <PIIExportDialog
        open={showDialog}
        onOpenChange={setShowDialog}
        onConfirm={handleConfirm}
        exportType="Referrals"
        isLoading={isExporting}
      />
    </>
  );
};
